import React, { useState } from 'react';

const faqs = [
  {
    question: 'Why can I only install from Safari on iPhone?',
    answer: 'Apple restricts PWA installation to Safari on iOS devices. Other browsers like Chrome on iOS cannot trigger the Add to Home Screen prompt for PWAs.'
  },
  {
    question: 'Will this use storage on my device?',
    answer: 'Yes, a small amount of storage is used to cache the app shell and key assets for offline access. This is typically less than 10MB.'
  },
  {
    question: 'Is this different from downloading from the App Store?',
    answer: 'Yes. This is a Progressive Web App (PWA) installed directly from your browser — no App Store required. It runs in a dedicated window and feels like a native app.'
  },
  {
    question: 'Can I uninstall it?',
    answer: 'Yes. On iOS, press and hold the icon then tap Remove App. On Android, press and hold the icon and drag to Uninstall, or go to Settings > Apps.'
  },
  {
    question: 'Will I get updates automatically?',
    answer: 'Yes. The app checks for updates in the background and applies them the next time you open it. You always have the latest version.'
  }
];

const FAQItem = ({ question, answer }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="border-b border-border last:border-0">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between py-3 text-left gap-3"
      >
        <span className="text-sm font-medium text-foreground">{question}</span>
        <svg
          className={`w-4 h-4 text-muted-foreground flex-shrink-0 transition-transform ${open ? 'rotate-180' : ''}`}
          fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth={2}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      {open && (
        <p className="text-sm text-muted-foreground pb-3 pr-6">{answer}</p>
      )}
    </div>
  );
};

const InstallFAQ = () => {
  return (
    <div className="bg-card border border-border rounded-xl p-5">
      <h2 className="text-base font-semibold text-foreground mb-3">Common questions</h2>
      <div>
        {faqs?.map((faq, index) => (
          <FAQItem key={index} question={faq?.question} answer={faq?.answer} />
        ))}
      </div>
    </div>
  );
};

export default InstallFAQ;
